import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import * as publishIntakeActions from './publish-intake-form.actions';
import * as modifyIntakeActions from '../modify-intake-form/modify-intake-form.actions';
import * as sitesActions from '../../permissions/touchpoint/site-list-folder/site-list.actions';
import { LoadingPane, CopyButton, SaveButton } from '../../common';
import { Title } from '../../layout';
import { tenantHelpers } from '../../tenantInfo';
import { validateIntakeFormActions, IntakeFormValidation } from '../validate-intake-form';
import './publish-intake-form.scss';

const publishValidationMessage = "This intake form cannot be published at this time.";
const retractValidationMessage = "This intake form is currently published, " +
  "but applicants will not be able to fill it out due to the issues listed below. " +
  "You should retract the form, resolve the issues below, then publish again."

export class PublishIntakeFormComponent extends Component {

  componentDidMount() {
    const { modifyIntakeActions, sitesActions, validateIntakeFormActions, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchForm } = modifyIntakeActions;
    const { fetchCompleteSiteList, fetchProgramsForSite } = sitesActions || {};
    const { validateExistingIntakeForm } = validateIntakeFormActions;

    fetchForm(id)
      .then(form => {
        const { siteId, programId } = form || {};
        if(this.shouldFetchSite(siteId)) {
          fetchCompleteSiteList();
        }

        if(this.shouldFetchProgram(siteId, programId)) {
          fetchProgramsForSite(siteId)
        }
      });

    validateExistingIntakeForm(id);
  }

  componentWillUpdate(nextProps, nextState) {
    const { modifyIntakeActions, sitesActions, validateIntakeFormActions, match } = nextProps;
    const { params } = match || {};
    const { id } = params || {};
    const { fetchForm } = modifyIntakeActions;
    const { fetchCompleteSiteList, fetchProgramsForSite } = sitesActions || {};


    const { match : oldMatch } = this.props;
    const { params : oldParams } = oldMatch || {};
    const { id : oldId } = oldParams || {};

    fetchForm(id)
      .then(form => {
        const { siteId, programId } = form || {};
        if(this.shouldFetchSite(siteId)) {
          fetchCompleteSiteList();
        }

        if(this.shouldFetchProgram(siteId, programId)) {
          fetchProgramsForSite(siteId)
        }
      });

    if(id !== oldId) {
      validateIntakeFormActions.validateExistingIntakeForm(id);
    }
  }

  shouldFetchSite(siteId) {
    if(!siteId)
      return false;
    const { sites } = this.props;
    const { siteListState, isFetchingMultiPageSites } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);
    return !isFetchingMultiPageSites && !site;
  }

  shouldFetchProgram(siteId, programId) {
    if(!siteId || !programId)
      return false;
    const { sites } = this.props;
    const { programLists } = sites || {};
    var programsState = siteId && programLists && programLists.get(siteId);
    const { isFetching, data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);
    return !isFetching && !program;
  }

  handlePublish() {
    const { modifyIntake, publishIntakeActions,  match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { intakeForms } = modifyIntake || {};
    const formState = intakeForms && intakeForms.get(id);
    const { data } = formState || {};

    const formName = data && data.name;
    publishIntakeActions.publishForm(id)
      .then(val => {
        toastr.success('Success', `You have successfully published ${formName}.`);
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  handleRetract() {
    const { publishIntakeActions,  match } = this.props;
    const { params } = match || {};
    const { id } = params || {};

    publishIntakeActions.retractForm(id)
      .then(val => {
        toastr.success('Success', `You have retracted this intake form. You can re-publish it when you like.`);
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  handleCopyError(error) {
    toastr.error("Failed to Copy", "unable to copy link text, your browser may not support this functionality");
  }

  render() {
    const { sites, modifyIntake, publishIntake, validateIntake, redirectTo, match } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { intakeForms } = modifyIntake || {};
    const formState = intakeForms && intakeForms.get(id);
    const { isFetching, err, data } = formState || { isFetching : false };

    const isPublished = data && data.isPublished;
    const formName = !!data ? ` "${data.name}"` : '';

    const siteId = data && data.siteId;
    const { programLists, siteListState, isFetchingMultiPageSites } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const site = siteData && siteData.find(res => res.id === siteId);
    const siteName = site ? site.name : '';

    const programId = data && data.programId;
    var programsState = siteId && programLists && programLists.get(siteId);
    const { isFetching : programsLoading, data : programList } = programsState || {};
    const program = programList && programList.find(val => val.id === programId);
    const programName = program ? program.name : '';
    const siteAndProgram = !!siteName && !!programName ? ` for ${siteName} / ${programName}` : '';

    const { publishing, retracting } = publishIntake || {};
    const publishState = publishing && publishing.get(id);
    const { isFetching : isPublishing } = publishState || {};

    const retractState = retracting && retracting.get(id);
    const { isFetching : isRetracting } = retractState || {};

    const introText = isPublished ?
      "You can retract this published intake form from the following unique Web page." +
        " Visitors to the page will not be able to view or complete the form." :
      "You can publish this intake form to the following unique Web page, which will show only this form."

    var infoText = "";
    var validationMessage = "";
    if(isPublished) {
      infoText += "Once retracted, you can publish it again as needed.";
      validationMessage = retractValidationMessage;
    }
    else {
      infoText += "Once published, you can display it on a kiosk, email the link to potential participants, or place the link on your Web site.";
      validationMessage = publishValidationMessage;
    }

    var url = tenantHelpers.getParticipantIntakeUrl(id);

    var validationState = validateIntake.getIn(['formValidation', id]);
    const { isFetching: validatingForm, err: validationError, data: intakeValidationResult } = validationState || {};

    return (
      <LoadingPane
        id='main-display'
        isLoading={isFetching || programsLoading || isFetchingMultiPageSites}
        err={err}
        loadingMessage={'Loading intake form...'}>
        <Title title="Publish Intake Form"/>
        <h1>Publishing{formName}{siteAndProgram}</h1>
        <LoadingPane
          id='validation'
          isLoading={validatingForm}
          err={validationError}
          loadingMessage={'Validating form...'}>
          <IntakeFormValidation validationResult={intakeValidationResult} titleMessage={validationMessage}/>
        </LoadingPane>
        <p>{introText}</p>
        <div>
          { isPublished ? <span>Published: </span> : null}
          <a id="publish-link" className="publish-link" href={url}>{url}</a>
          <CopyButton
            copyTarget="publish-link"
            text="Copy Link"
            onError={err => this.handleCopyError(err)}/>
        </div>
        <p>{infoText}</p>
        <div className="actions">
          { isPublished ? (
            <SaveButton
              id="retract"
              text="Retract"
              saving={isRetracting}
              savingText="Retracting..."
              onSave={() => this.handleRetract()}/>
          ) : (
            <SaveButton
              id="publish"
              text="Publish"
              disabled={validatingForm || (intakeValidationResult && !intakeValidationResult.passedValidation)}
              saving={isPublishing}
              savingText="Publishing..."
              onSave={() => this.handlePublish()}/>
          )}
          <button
            id="cancel"
            className="btn btn-default"
            onClick={() => redirectTo('/intake-forms')}>
            Cancel
          </button>
        </div>
      </LoadingPane>
    );
  }
}

PublishIntakeFormComponent.propTypes = {
  publishIntake : PropTypes.any,
  modifyIntake : PropTypes.any,
  sites : PropTypes.any,
  publishIntakeActions : PropTypes.any,
  modifyIntakeActions : PropTypes.any,
  sitesActions : PropTypes.any,
  redirectTo : PropTypes.func
};

const mapStateToProps = ({ modifyIntake, sites, publishIntake, validateIntake }) => {
  return {
    publishIntake,
    modifyIntake,
    sites,
    validateIntake
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    publishIntakeActions: bindActionCreators(publishIntakeActions, dispatch),
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
    validateIntakeFormActions: bindActionCreators(validateIntakeFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PublishIntakeFormComponent);
